import { render, staticRenderFns } from "./ShadowInput.vue?vue&type=template&id=2431065b&"
import script from "./ShadowInput.vue?vue&type=script&lang=ts&"
export * from "./ShadowInput.vue?vue&type=script&lang=ts&"
import style0 from "./ShadowInput.vue?vue&type=style&index=0&id=2431065b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports